import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "smc_cookie_consent";

function updateConsent(granted) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    const state = granted ? "granted" : "denied";
    window.gtag("consent", "update", {
      analytics_storage: state,
      ad_storage: state,
      ad_user_data: state,
      ad_personalization: state,
    });
  }
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      setVisible(true);
    } else if (saved === "accepted") {
      updateConsent(true);
    }
  }, []);

  const choose = (accepted) => {
    localStorage.setItem(STORAGE_KEY, accepted ? "accepted" : "rejected");
    updateConsent(accepted);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 inset-x-4 sm:bottom-6 sm:left-6 sm:right-auto z-[100] sm:max-w-md"
        >
          <div className="backdrop-blur-xl bg-[#FFF7ED]/85 border border-[#F59E0B]/30 shadow-[0_0_40px_rgba(0,0,0,0.6)] p-6">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 shrink-0 flex items-center justify-center border border-[#F59E0B]/40 bg-[#F59E0B]/10">
                <Cookie className="w-5 h-5 text-[#F59E0B]" />
              </div>
              <div>
                <h3 className="font-serif-display text-lg font-semibold text-[#232323]">
                  We value your privacy
                </h3>
                <p className="mt-2 text-sm text-[#666666] leading-relaxed">
                  We use cookies to analyze traffic and improve your experience. You can accept
                  all cookies or continue with only essential ones. Read our{" "}
                  <a href="/privacy" className="text-[#F59E0B] underline hover:text-[#E6B31E]">
                    Privacy Policy
                  </a>.
                </p>
              </div>
            </div>

            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <button
                data-testid="cookie-accept"
                onClick={() => choose(true)}
                className="flex-1 px-6 py-3 text-sm font-bold uppercase tracking-wider bg-[#4338CA] text-[#232323] hover:bg-[#3730A3] transition-colors"
              >
                Accept All
              </button>
              <button
                data-testid="cookie-reject"
                onClick={() => choose(false)}
                className="flex-1 px-6 py-3 text-sm font-semibold uppercase tracking-widest border border-[#E5D8C8] text-[#353535] hover:border-[#F59E0B] hover:text-[#F59E0B] transition-colors"
              >
                Essential Only
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
